export default {
  reasons: (state) => state.reasons,
};


